<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="caseDetailsState.fetching" class="empty-view">
    <ArgonLoader />
  </div>
  <div v-else-if="isEmpty(caseDetailsState.details)" class="empty-container">
    <div class="card w-100" style="padding: 100px 0;">
      <div class="card-body py-0">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-7 mx-auto text-center">
            <h3 class="title-color">No case details found.</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row mb-2 mb-md-0">
      <div class="col-12 col-lg-8">
        <div class="mb-3 card mt-lg-0">
          <div class="card-header pb-0">
            <div class="row">
              <div class="col-6">
                <h4 class="mb-0">
                  <a class="text-primary" :href="caseDetailsState.details?.decisionUrl || ''" target="_blank">
                      {{ capitalizeFirstLetter(caseDetailsState.details?.caseNo || '-') }}
                  </a>
                </h4>
              </div>
              <div v-if="(caseDetailsState.details?.caseType || []).length > 0" class="col-6">
                  <div class="float-end">
                    <span class="badge rounded-pill badge-primary badge-lg">
                      {{ caseDetailsState.details?.caseType }}
                    </span>
                  </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div v-if="(caseDetailsState.details?.result || []).length > 0" class="row">
              <div class="col-12">
                <h5 class="text-primary">Result</h5>
                <span class="fw-bolder">
                  <i v-if="String(caseDetailsState.details?.result ?? '').toLowerCase().includes('claimant')" class="text-primary fa fa-circle"></i>
                  <i v-if="String(caseDetailsState.details?.result ?? '').toLowerCase().includes('respondent')" class="text-danger fa fa-circle"></i>
                  <i v-if="String(caseDetailsState.details?.result ?? '').toLowerCase().includes('partially')" class="text-warning fa fa-circle"></i>
                  <i v-if="String(caseDetailsState.details?.result ?? '').toLowerCase().includes('settled')" class="text-success fa fa-circle"></i>
                  {{ capitalizeFirstLetter(caseDetailsState.details?.result ?? 'No Result') }} 
                </span>
              </div>
            </div>
            <div class="row mt-3">
              <div v-if="(caseDetailsState.details?.claimant || []).length > 0" class="col-sm-6">
                <h5 class="text-primary">Claimant</h5>
                <div v-for="(cases, i) of caseDetailsState.details.claimant" :key="`${i}`" class="card case-card mt-3" style="min-height: auto;">
                  <div class="text-sm lh-base similar-case-title d-flex align-items-center">
                  <!-- <img :src="require('@/assets/img/user.png')" alt="file icon" class="d-block w-20 h-20" /> -->
                  <img :src="cases?.company?.companyLogoUrl ? cases?.company?.companyLogoUrl : require('@/assets/img/user.png')" alt="file icon" class="d-block" style="width: 50px; height: 50px; object-fit: contain;"/>
                  <span class="fw-bold" style="margin-left: 15px;">{{ cases?.name ?? 'No Result' }}</span>
                  </div>
                  <div class="mt-3">
                    <div class="text-sm mt-1"><span class="fw-bolder">Representation:</span></div>
                    <div v-for="(rep, j) of cases?.representations" :key="`${j}`">
                      <span>
                        {{ rep?.name }}<span class="font-weight-bold font-italic">{{ ( rep?.instructedBy ? ', '+rep?.instructedBy : '') }}</span>
                      </span>
                    </div>
                  </div>
                  <!-- <div class="text-sm mt-1"><span class="fw-bolder">Representation:</span> {{ getrepresentations(cases?.representations, 'name') }} </div>
                  <div class="text-sm mt-1"><span class="fw-bolder">Instructed by:</span> {{ getrepresentations(cases?.representations, 'instructer') }} </div> -->
                </div>
              </div>
              <div v-if="(caseDetailsState.details?.respondent || []).length > 0" class="col-sm-6">
                <h5 class="text-primary">Respondent</h5>
                <div v-for="(cases, i) of caseDetailsState.details.respondent" :key="`${i}`" class="card case-card mt-3" style="min-height: auto;">
                  <div class="text-sm lh-base similar-case-title d-flex align-items-center">
                  <!-- <img :src="require('@/assets/img/user.png')" alt="file icon" class="d-block w-20 h-auto" /> -->
                  <img :src="cases?.company?.companyLogoUrl ? cases?.company?.companyLogoUrl : require('@/assets/img/user.png')" alt="file icon" class="d-block" style="width: 50px; height: 50px; object-fit: contain;"/>
                  <span class="fw-bold" style="margin-left: 15px;">{{ cases?.name ?? 'No Result' }}</span>
                  </div>
                  <div class="mt-3">
                    <div class="text-sm"><span class="fw-bolder">Representation:</span></div>
                    <div v-for="(rep, j) of cases?.representations" :key="`${j}`">
                      <span>
                        {{ rep?.name }}<span class="font-weight-bold font-italic">{{ ( rep?.instructedBy ? ', '+rep?.instructedBy : '') }}</span>
                      </span>
                    </div>
                  </div>
                  <!-- <div class="text-sm mt-1"><span class="fw-bolder">Representation:</span> {{ getrepresentations(cases?.representations, 'name') }} </div>
                  <div class="text-sm mt-1"><span class="fw-bolder">Instructed by:</span> {{ getrepresentations(cases?.representations, 'instructer') }} </div> -->
                </div>
              </div>
            </div>
            <div  v-if="caseDetailsState?.details?.heardBefore && caseDetailsState?.details?.heardBefore.length > 0" class="row mt-3">
              <h5 class="text-primary">Judge(s)</h5>
              <div class="mt-2">
                <template v-if="(caseDetailsState?.details?.heardBefore || []).length > 0">
                  <span v-for="(judge, i) of (caseDetailsState?.details?.heardBefore || [])" :key="`${i}`"
                    class="badge rounded-pill badge-lg mt-2"
                    style="line-height: inherit !important; text-transform: none !important; white-space: break-spaces !important; margin-right: 8px; background-color: #702962;">
                    {{ judge.name }}
                  </span>
                </template>
                <span v-else>-</span>
              </div>


              <!-- <div v-for="(judge, i) of caseDetailsState?.details?.heardBefore" :key="`${i}`" class="col-sm-4">
                <div class="card case-card mt-2">
                  <div class="text-sm lh-base similar-case-title d-flex">
                    <img :src="require('@/assets/img/user.png')" alt="file icon" class="d-block w-20 h-auto" style="object-fit: contain;" /> 
                    <div class="vr" style="margin-left: 8px;"></div>
                    <span class="mt-1 fw-bold" style="margin-left: 10px;">{{ judge.name }}</span>
                  </div>
                </div>
              </div> -->
            </div>
            <div class="row mt-3">
              <div v-if="(caseDetailsState.details?.category || []).length > 0" class="col-sm-12">
                <h5 class="text-primary">Jurisdiction codes</h5>
                  <div>
                    <template v-if="(caseDetailsState.details?.category || []).length > 0">
                      <span v-for="code of (caseDetailsState.details?.category || [])" :key="code"
                        class="badge rounded-pill badge-lg mt-2"
                        style="line-height: inherit !important; text-transform: none !important; white-space: break-spaces !important; margin-right: 8px; background-color: #702962;">
                        {{ code || '' }}
                      </span>
                    </template>
                    <span v-else>-</span>
                  </div>
              </div>
            </div>
            <div class="row mt-3">
              <h5 class="text-primary">Summary <img :src="require('@/assets/img/ai.png')" alt="file icon" style="width: 22px; height: 22px;"></h5>
              <div class="col-sm-12">
                <div v-if="(caseDetailsState?.details?.summary || []).length > 0">
                  <div v-for="(summaries, i) of (JSON.parse(caseDetailsState?.details?.summary) || [])" :key="i" class="mt-2">
                    <span class="text-primary h6">{{ i.replace(/[_]/g,' ') }}</span>
                    <ul class="mt-1">
                      <li v-for="(sum, j) of (summaries || [])" :key="j">
                          {{ sum }}
                      </li>
                    </ul>
                  </div>
                </div>
                <span v-else>-</span>
              </div>
            </div>
            <div class="row mt-3">
              <div  v-if="caseDetailsState?.details?.lawReferences && caseDetailsState?.details?.lawReferences.length > 0" class="row mt-3">
              <h5 class="text-primary">Law References</h5>
              <div class="mt-2">
                <template v-if="(caseDetailsState?.details?.lawReferences || []).length > 0">
                  <span v-for="(lawReferences, i) of (caseDetailsState?.details?.lawReferences || [])" :key="`${i}`"
                    class="badge rounded-pill badge-lg mt-2"
                    style="line-height: inherit !important; text-transform: none !important; white-space: break-spaces !important; margin-right: 8px; background-color: #702962;">
                    {{ lawReferences }}
                  </span>
                </template>
                <span v-else>-</span>
              </div>
              </div>
            </div>
            <div class="row mt-3">
              <div  v-if="caseDetailsState?.details?.caseReferences && caseDetailsState?.details?.caseReferences.length > 0" class="row mt-3">
              <h5 class="text-primary">Case References</h5>
              <div class="mt-2">
                <template v-if="(caseDetailsState?.details?.caseReferences || []).length > 0">
                  <span v-for="(caseReferences, i) of (caseDetailsState?.details?.caseReferences || [])" :key="`${i}`"
                    class="badge rounded-pill badge-lg mt-2"
                    style="line-height: inherit !important; text-transform: none !important; white-space: break-spaces !important; margin-right: 8px; background-color: #702962;">
                    {{ caseReferences }}
                  </span>
                </template>
                <span v-else>-</span>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div  class="col-12 col-lg-4">
        <timeline-list v-if="!isEmpty(caseDetailsState.details?.caseHistory)" title="Case Timeline" title-class="h5 text-primary">
          <timeline-item v-for="history of caseDetailsState.details?.caseHistory" :key="history.date"
            :icon="{ component: 'fa fa-circle', color: 'primary' }" :title="capitalizeFirstLetter(history.title)"
            :date-time="getFormatedDate(history.date || '', '', 'YYYY-MM-DD HH:mm', true)" />
        </timeline-list>
        <!-- <div class="float-end">
          <a type="button" class="btn btn-secondary mt-3" @click="caseReport(caseDetailsState.details?.caseNo)">Report</a>
        </div> -->
      </div>
    </div>
    <div v-if="(caseDetailsState.details?.fileLinks || []).length > 0" class="mb-3 card">
      <div class="card-header pb-0">
        <div class="row">
          <div class="col-12">
            <h5 class="mb-0 text-primary">
              Case Files
            </h5>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div v-for="file of (caseDetailsState.details?.fileLinks || [])" :key="file"
            class="col-6 col-md-2 case_file_container mb-2 mb-md-0">
            <a :href="file" target="_blank" class="text-center">
              <img :src="require('@/assets/img/pdf-icon.svg')" alt="file icon" class="d-block mx-auto w-30 h-auto" />
              <p class="text-sm mb-0 mt-2 text-capitalize">{{ getFileName(file) }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="!isEmpty(caseDetailsState.details?.cityData)" class="row mb-3">
      <div class="col-12">
        <div class="card">
          <div class="p-3 card-body">
            <p class="text-lg mb-2">
              <strong>Address:</strong> {{ (caseDetailsState.details?.cityData.Address || '').replaceAll("\n", ", ") }}
            </p>
            <div id="case_details_map" class="leaflet" style="height: 400px;"></div>
          </div>
        </div>
      </div>
    </div> -->
    <div v-if="(caseDetailsState?.details?.applicableLawsAndRegulations ?? []).length > 0" class="card mb-3">
      <div class="card-header pb-0">
        <div class="d-flex align-items-center gap-3">
          <h5 class="mb-0 text-primary">
            Relevant Legislation
          </h5>
          <img :src="require('@/assets/img/ai.png')" height="20px">
        </div>
      </div>
      <div class="card-body p-3 pt-0 mt-0">
        <div id="CaseDetailsLawNRegulations" class="px-2 pt-3 accordion">
          <!-- <accordion-item v-for="(law, i) of caseDetailsState?.details?.applicableLawsAndRegulations ?? []"
            :key="`${law?.lawName}`" :accordian-button-class="`border-bottom rounded-0 px-0${i == 0 ? ' pt-0' : ''}`"
            accordian-body-class="px-0" parent-id="CaseDetailsLawNRegulations"
            :accordion-id="`heading_${(law?.lawName || '').replace(/[^a-zA-Z0-9]/g, '').replace(/ /g, '_')}`"
            :collapse-id="`collapse_${(law?.lawName || '').replace(/[^a-zA-Z0-9]/g, '').replace(/ /g, '_')}`"
            :active="false">
            <template #question>
              <div class="text-lg title-color">{{ law?.lawName || '-' }}</div>
            </template>
            <template #answer>
              <div v-html="law?.lawSummary || '-'"></div>
            </template>
          </accordion-item> -->
          <ul class="mb-2">
            <li v-for="(law, i) of caseDetailsState?.details?.applicableLawsAndRegulations ?? []" :key="`${i}_${law}`">
              {{ law || '' }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="(caseDetailsState.details?.referredCases || []).length > 0" class="card mb-3">
      <div class="card-header pb-0">
        <div class="d-flex align-items-center gap-3">
          <h5 class="mb-0 text-primary">
            Case Law
          </h5>
          <img :src="require('@/assets/img/ai.png')" height="20px">
        </div>
      </div>
      <div class="card-body p-3">
        <ul class="mb-2">
          <li v-for="(caseTitle, i) of caseDetailsState.details?.referredCases || []" :key="`${i}_${caseTitle}`">
            {{ caseTitle || '' }}
          </li>
        </ul>
      </div>
      <!-- <div class="card-body p-3 pt-0 mt-0 overflow-auto" style="max-height: 400px;">
        <table class="table table-sm table-striped table-hover" style="table-layout: fixed; word-wrap: break-word;">
          <thead>
            <th scope="col">Case Name</th>
            <th class="text-center" scope="col">Date</th>
            <th class="text-center" scope="col">Claimant</th>
            <th class="text-center" scope="col">Case Type</th>
            <th scope="col">Respondent</th>
            <th scope="col">Point of Law</th>
            <th scope="col">Decision Files</th>
          </thead>
          <tbody>
            <tr
              v-for="(cityCase, i) of caseDetailsState.cityCases.slice(caseDetailsState.pageNo == 1 ? 0 : ((caseDetailsState.pageNo - 1) * caseDetailsState.dataSize), caseDetailsState.pageNo * caseDetailsState.dataSize)"
              :key="`${i}.${cityCase.id} `">
              <td class="value text-start align-baseline">
                <span v-if="isNewCase(cityCase)" class="badge badge-sm bg-primary text-white text-break me-1 mt-1">
                  New
                </span>
                <span class="case_title text-capitalize" @click="activeCaseDetailsTab(String(cityCase.id), cityCase?.caseName)">
                  {{ cityCase.caseName || '-' }}</span>
              </td>
              <td class="value text-center text-capitalize align-baseline">
                {{ !cityCase.caseDate ? '-' : `${getFormatedDate(cityCase.caseDate)}` }}
              </td>
              <td class="value text-center text-capitalize align-baseline">
                {{ capitalizeFirstLetter(cityCase.claimant || '-') }}
              </td>
              <td class="value text-center text-capitalize align-baseline">{{ cityCase.caseType }}</td>
              <td class="value text-capitalize align-baseline">
                {{ capitalizeFirstLetter(cityCase.respondent || '-') }}
              </td>
              <td class="value align-baseline">
                <div v-if="cityCase.category" class="d-flex align-items-center flex-wrap gap-2">
                  <span v-for="code of cityCase.category" :key="code"
                    class="badge badge-sm bg-primary text-wrap text-break text-start lh-base"
                    style="text-transform: none !important;">
                    {{ code }}
                  </span>
                </div>
                <span v-else class="text-center">-</span>
              </td>
              <td class="text-center align-baseline">
                <div class="d-flex align-items-center justify-content-center flex-wrap gap-1">
                  <template v-if="cityCase.fileLinks && cityCase.fileLinks.length > 0">
                    <a v-for="file of cityCase.fileLinks" :key="file" :href="file" target="_blank">
                      <img :src="require('@/assets/img/pdf-icon.svg')" alt="file icon" class="me-2"
                        style="height: 25px;" />
                    </a>
                  </template>
                  <span v-else class="text-center">-</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="caseDetailsState.cityCases.length == 0">
          <h4 class="text-center text-lg">No cases found</h4>
        </div>
      </div>
      <div v-if="caseDetailsState.cityCases.length > caseDetailsState.dataSize" class="card-footer px-0">
        <div class="pagination-container">
          <vue-awesome-paginate v-model="caseDetailsState.pageNo" :max-pages-shown="3" :items-per-page="caseDetailsState.dataSize"
            :total-items="caseDetailsState.cityCases.length" @click="onPageNoChange">
            <template #prev-button>
              <svg xmlns="http://www.w3.org/2000/svg" fill="black" width="10" height="10" viewBox="0 0 24 24">
                <path d="M8.122 24l-4.122-4 8-8-8-8 4.122-4 11.878 12z" />
              </svg>
            </template>
            <template #next-button>
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="black" width="10" height="10" viewBox="0 0 24 24">
                  <path d="M8.122 24l-4.122-4 8-8-8-8 4.122-4 11.878 12z" />
                </svg>
              </span>
            </template>
          </vue-awesome-paginate>
        </div>
      </div> -->
    </div>
    <div v-if="caseDetailsState.similarCasesData.length > 0" class="card">
      <div class="card-header pb-0">
        <h5 class="mb-0 text-primary">
          Similar Cases
        </h5>
      </div>
      <div class="card-body p-0 d-flex">
        <div class="similar-case-card-parent-container p-3">
          <div v-for="(simCas, i) of caseDetailsState.similarCasesData" :key="`${i}_${simCas.caseNo}`"
            class="card similar-case-card" @click="activeCaseDetailsTab(String(simCas.caseNo), simCas?.caseName)">
            <div class="text-sm lh-base similar-case-title">
              {{ simCas.caseName || '-' }}
            </div>
            <div class="text-sm">Date: {{ getFormatedDate(simCas?.startDate || "", '', 'YYYY-MM-DD', true) }}</div>
            <div class="progress progress-xs mb-0 mt-2" style="height: 20px;">
              <div :class="`progress-bar bg-male`" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                :aria-valuenow="Number(simCas?.similarityScore || 0)"
                :style="{ width: `${Number(simCas?.similarityScore || 0)}` + '%' }">
                <span class="text-xxs lh-xxs font-weight-bold">
                  {{ Number(Number(Number(simCas?.similarityScore || 0)).toFixed(2)) }}%
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// import moment from "moment";
import { useStore } from "vuex";
// import uniqBy from "lodash-es/uniqBy";
import isEmpty from "lodash-es/isEmpty";
// import orderBy from "lodash-es/orderBy";
import { watch, computed, reactive } from "vue";

// import AccordionItem from '@/views/pages/components/AccordionItem2.vue'; 
import TimelineList from '@/examples/Cards/TimelineList.vue';
import TimelineItem from '@/examples/Cards/TimelineItem.vue';
import ArgonLoader from '@/components/ArgonLoader.vue';

import {
  // isNewCase,
  handleError,
  getFormatedDate,
  capitalizeFirstLetter,
} from '@/utils/utils.js';
import elasticSearchApiInstance, { getSimilarCaseFilter } from "@/utils/elasticSearch";
import eventBus from '@/utils/eventBus';

const store = useStore();

const caseDetailsState = reactive({
  details: {},
  fetching: false,
  similarCasesData: [],
  pageNo: 1,
  dataSize: 50,
});

// const caseDetailsMap = ref(null);
const selectedCase = computed(() => store.getters['dashboard/caseDetailFilters'].selectedCase || '');

const getCaseDetails = async (id) => {
  if (id) {
    try {
      caseDetailsState.fetching = true;
      const filterData = {
        query: { bool: { must: { match: { caseNo: id } } } }
      };
      const response = await elasticSearchApiInstance.post('/_search', filterData);
      const { hits = [] } = response?.data?.hits ?? {};
      const cDetail = hits.find(c => c._source.caseNo == id) || {};
      const similarCasesResponse = await elasticSearchApiInstance.post('/_search', getSimilarCaseFilter(cDetail?._index, cDetail?._id));
      const similarCases = (similarCasesResponse.data?.hits?.hits ?? []);
      caseDetailsState.details = cDetail?._source ?? {};
      caseDetailsState.similarCasesData = similarCases.map(c => ({
        ...(c?._source ?? {}),
        similarityScore: c?._score ?? 0,
      }));

      // setTimeout(() => {
      //   renderMap();
      // }, 2000);

      setTimeout(() => {
        caseDetailsState.fetching = false;
        setTimeout(() => {
          document.querySelector('main').scrollTo({ top: 0, left: 0, behavior: 'auto' });
        });
      }, 1000);
    } catch (error) {
      caseDetailsState.fetching = false;
      const errorMessage = handleError(error);
      if (errorMessage) {
        this.$swal({
          title: 'Error!',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: 'Okay',
          customClass: {
            confirmButton: "btn bg-success",
          },
          buttonsStyling: false,
        });
      }
    }
  } else {
    caseDetailsState.fetching = false;
  }
};
// const getrepresentations = (rep, type) => {
//   if(type == 'name') {
//     return rep.map((val) => val?.name).join(', ');
//   } else {
//     return rep.map((val) => val?.instructedBy).join(', ');
//   }
// }

// const getclaimant = (claimant) => {
//   return claimant.map((val) => val.name).join(', ');
// }

// const getrespondent = (respondent) => {
//   return respondent.map((val) => val.name).join(', ');
// }

// const getCaseJudgement = () => {
//   if (!isEmpty(caseDetailsState.details?.result)) {
//     return (caseDetailsState.details?.result || []).map(r => {
//       if (r && r.toLowerCase() == 'Respondent won') {
//         return `${capitalizeFirstLetter((caseDetailsState?.details?.respondent || []).join(', '))} won the case.`;
//       } else if (r && r.toLowerCase() == 'Claimant won') {
//         return `${capitalizeFirstLetter((caseDetailsState?.details?.claimant || []).join(', '))} won the case.`;
//       } else if (r && r.toLowerCase() == 'Settled') {
//         return 'The case was settled.';
//       } else {
//         return 'Not decided yet.';
//       }
//     }).join("\n")
//   } else {
//     return '-';
//   }
// };

const getFileName = (fileUrl) => {
  if (!fileUrl) return '';
  let name = fileUrl[0]?.split('/').pop().replace(/[_-]/g,' ');
  if (name.includes('.')) {
    name = name.split('.');
    name.pop();
    name = name.join('.');
  }
  return capitalizeFirstLetter(name);
};


// const activeCompanyTab = () => {
//   const get = document.getElementsByClassName("company-tab")[0];
//   if (get) {
//     setTimeout(() => {
//       get.click();
//       get.classList.add('active');
//     }, 200);
//   }
// };
// 
// const onRespondantClick = (respondent) => {
//   if (isEmpty(respondent)) return null;
//   store.commit('dashboard/updateCompanyFilters', { selectedCompany: respondent.id || "" });
//   activeCompanyTab();
// };

// const onPageNoChange = (page) => {
//   caseDetailsState.pageNo = page;
// };

// const renderMap = () => {
//   if (!isEmpty(caseDetailsState.details?.cityData)) {
//     if (caseDetailsMap.value) {
//       caseDetailsMap.value.remove();
//       caseDetailsMap.value = null;
//     }
//     setTimeout(() => {
//       const latLong = [caseDetailsState.details?.cityData?.Lat, caseDetailsState.details?.cityData?.Lon];
//       caseDetailsMap.value = L.map('case_details_map', {
//         zoom: 15,
//         latlng: latLong,
//       }).setView(latLong, 15);

//       new L.tileLayer(
//         'https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png',
//         {
//           attribution: '',
//           subdomains: 'abcd',
//         }
//       ).addTo(caseDetailsMap.value);
//       const icon = L.icon({
//         iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//         iconUrl: require('leaflet/dist/images/marker-icon.png'),
//         shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
//         iconSize: [25, 41],
//         iconAnchor: [12, 41],
//         popupAnchor: [1, -34],
//         tooltipAnchor: [16, -28],
//         shadowSize: [41, 41],
//       });
//       L.marker(latLong, { icon }).addTo(caseDetailsMap.value);
//     }, 1000);
//   }
// };

const activeCaseDetailsTab = (caseId, caseName) => {
  store.commit('dashboard/updateCaseDetailFilters', { selectedCase: caseId });
  eventBus.emit('on-case-details-change', { id: caseId, query: caseName });
};

// const caseReport = (caseNo) => {
//   console.log(caseNo);
// }

watch(() => selectedCase.value, (newId) => {
  if (newId) {
    caseDetailsState.fetching = true;
    getCaseDetails(newId);
  }
});
getCaseDetails(selectedCase.value);

</script>
<style scoped>
.empty-container {
  align-items: flex-start !important;
}

th {
  font-size: 0.9rem;
  text-wrap: wrap;
  text-align: center;
  padding: 0.75rem 0.25rem !important;
}

td.value {
  font-size: 0.8rem;
  line-height: 1.2rem;
  vertical-align: middle;
  text-align: center;
  text-wrap: wrap;
}

.case_file_container {
  transition: all;
  transition-duration: 300ms;
}

.case_file_container:hover,
.case_file_container:active,
.case_file_container:focus-visible,
.case_file_container:focus-within,
.case_file_container:target,
.case_file_container:visited,
.case_file_container:focus {
  scale: 1.1;
}

.case_file_container:hover>a>p,
.case_file_container:active>a>p,
.case_file_container:focus-visible>a>p,
.case_file_container:focus-within>a>p,
.case_file_container:target>a>p,
.case_file_container:visited>a>p,
.case_file_container:focus>a>p {
  color: rgb(var(--bs-primary-rgb)) !important;
}

.bg-orange {
  background-color: #FFBE0B;
}

.bg-purple {
  background-color: #702962;
}

@media only screen and (max-width : 768px) {
  table {
    table-layout: auto !important;
  }

  .th {
    padding: 0.75rem 1.25rem !important;
  }
}
</style>